import type { ClientKind } from '@/kinds/kind'
import { agentRunSpec, agentRunStatus, type AgentRunSpec, type AgentRunStatus } from './schema'
import { apply, defaults, displayName, initialStatus } from './apply'

export type { AgentRunResource } from './apply'
export type { AgentRunSpec, AgentRunStatus } from './schema'

const Nothing = () => null

export const agentRunKind: ClientKind<AgentRunSpec, AgentRunStatus> = {
  name: 'AgentRun',
  version: 1,
  spec: agentRunSpec,
  status: agentRunStatus,
  defaults,
  validate: () => [],
  initialStatus,
  displayName,
  apply,
  actions: ['say', 'interrupt', 'end'],
  ListRow: Nothing,
  Detail: Nothing,
  Form: Nothing,
  workspaceScoped: true,
}
